import { render, staticRenderFns } from "./u-card-elevated-tile.vue?vue&type=template&id=918b380c&scoped=true"
import script from "./u-card-elevated-tile.vue?vue&type=script&lang=js"
export * from "./u-card-elevated-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918b380c",
  null
  
)

export default component.exports